import React, {useState, useEffect, useMemo, useRef} from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DrawingManager, Polygon, OverlayView} from "@react-google-maps/api"
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase-config"
import { AppCTX } from '../data/AppContext';

const saveAssignAreaButtonPosition = 6
const continueOrDeleteButtonPosition = 4

function AreaManager ({zoomLevel}) {
    const {
        user,
        map,
        teamData,
        setTeamData,
        setNewProspect,
        newProspect,
        updateTeamData
    } = React.useContext(AppCTX);

    const [open, setOpen] = useState(false)
    // const [newTeamData, setNewTeamData] = useState(teamData)
    const [currentPolygon, setCurrentPolygon] = useState(null)
    const [transparentPolygons, setTransparentPolygons] = useState(false)
    const [areaManagerActive, setAreaManagerActive] = useState(false)
    const [showAreaManagerbutton, setShowAreaManagerbutton] = useState(true)
    const [assignAreaTo, setAssignAreaTo] = useState(null)
    const finalizeAreaBtn = useRef(null)
    const drawingManagerRef = useRef(null)
    const areaManagerBtn = useRef(null)

    const polygonOptions = {
        fillOpacity: 0.3,
        fillColor: '#ff0000',
        strokeColor: '#ff0000',
        strokeWeight: 2,
        draggable: true,
        editable: true,
        clickable: false,
        geodesic:true,
    }

    const drawingManagerOptions = {
        polygonOptions: polygonOptions,
        drawingControl: false,
        drawingMode: areaManagerActive&&currentPolygon==null? 'polygon' : null,
    }

    useEffect(() => {
        if(zoomLevel === 16 || zoomLevel === 20) {
            setTransparentPolygons(true)
        }else if (zoomLevel === 15){
            setTransparentPolygons(false)
        }
    },[zoomLevel])

    const calculatePolygonCenter = (vertices) => {
        if (vertices.length === 0) {
          return null;
        }

        // Calculate the average latitude and longitude
        const avgLat = vertices.reduce((sum, vertex) => sum + vertex.lat, 0) / vertices.length;
        const avgLng = vertices.reduce((sum, vertex) => sum + vertex.lng, 0) / vertices.length;
        console.log(avgLat, avgLng)
        return { lat: avgLat, lng: avgLng };
      };

    const handleAssignArea = (name) => {
        setOpen(false)
        setAssignAreaTo(name)
    }

    const renderAreas = useMemo(() => {
        let areas = []
        if(teamData?.areas === undefined) return null
        for(const area in teamData.areas){
            let color = teamData.members.filter((members) => members.name===area)[0]?.color;
            const polygonOptions = {
                fillOpacity: transparentPolygons?0:0.3,
                fillColor: color,
                strokeColor: color,
                strokeWeight: 2,
                draggable: false,
                editable: false,
                clickable: false,
                geodesic:true,
            }
            let areaPolygon = <Polygon
                key={area}
                options={polygonOptions}
                paths={teamData.areas[area]}
            />
            areas.push(areaPolygon)
            // let areaPolygon = (
            //     <Polygon key={area} options={polygonOptions} paths={teamData.areas[area]}>
            //       {!transparentPolygons && (
            //         <InfoWindow position={calculatePolygonCenter(teamData.areas[area])}>
            //           <div>
            //             {area}
            //           </div>
            //         </InfoWindow>
            //       )}
            //     </Polygon>
            //   );
            let overlay = null;
            if (!transparentPolygons) {
                overlay = (
                    <OverlayView
                        key={area+'1'}
                        position={calculatePolygonCenter(teamData.areas[area])}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                        <div style={{
                            position: "absolute",
                            color:"white",
                            padding: "5px",
                            fontSize: "14px",
                            transform: "translate(-50%, -50%)", // Center the overlay
                            maxWidth: "100px", // Set a fixed max width
                        }}>
                        {area}
                      </div>
                    </OverlayView>
                  );
                areas.push(overlay)
            }
        }
        
        return(areas)
    },[teamData, transparentPolygons])

    const finalizeArea = () =>{
        const paths = currentPolygon.getPath().getArray();
        let pathArr = []
        paths.forEach ((path)=>{
            const coords = {lat: path.lat(), lng: path.lng()}
            pathArr.push(coords)
        })
        // we are now updating the team data locally first
        if(teamData.hasOwnProperty('areas')){
            console.log("previous team areas", teamData.areas)
            let update = {...teamData.areas, [assignAreaTo]: pathArr}
            update = {...teamData, areas: update}

            console.log("new team areas", update)
            setTeamData(update)
            deleteCurrentPolygon()
            setShowAreaManagerbutton(true)
        }
        else{
            let update = {[assignAreaTo]: pathArr}
            update = {...teamData, areas: update}
            setTeamData(update)
            deleteCurrentPolygon()
            setShowAreaManagerbutton(true)
        }
    }

    const handlePolygonComplete = (polygon) => {
        try {
            setShowAreaManagerbutton(false)
            setCurrentPolygon(polygon)
            setOpen(true)
        } catch (err) {
            console.log(err)
        }
    }

    const handleAreaAssignment = () => {
        if(areaManagerActive){
            updateTeamData({...teamData})
            setAreaManagerActive(false);
        }else{
            setNewProspect({...newProspect,coords:false})
            setAreaManagerActive(true);
        }
    }

    const deleteCurrentPolygon = () => {
        currentPolygon.setMap(null)
        setCurrentPolygon(null)
        setShowAreaManagerbutton(true)
    }

    const handlePanToArea = () => {
        // Check if teamData and user are available
        if (teamData?.areas && user.uid) {
            // Get the user's assigned area coordinates from teamData.areas
            setTransparentPolygons(false)
            const userArea = teamData.areas[user.data.name];
            console.log(userArea)

            // Check if userArea is defined and contains at least one point
            if (userArea && userArea.length > 0) {
                const bounds = new window.google.maps.LatLngBounds();

                userArea.forEach(coords => {
                    bounds.extend(new window.google.maps.LatLng(coords.lat, coords.lng));
                });

                // Fit the map to the LatLngBounds, ensuring all points are visible
                map.fitBounds(bounds);
                console.log(bounds)
                // navigator.clipboard.writeText(bounds)
                // setStatus({notificationType:'success', message: 'address copied to clipboard'})
            }
        };
    }

    if(teamData==null)return(<></>)
    else return(
        <>
            {
                !showAreaManagerbutton?
                <>
                    <Button className='area-manager-options' variant="contained" onClick={finalizeArea}>
                        {'Continue'}
                    </Button>
                    <Button className='area-manager-options' variant="contained" color="error" onClick={deleteCurrentPolygon}>
                        {'Delete'}
                    </Button>
                </>
                :
                <></>
            }
            {
                user.uid===teamData.teamLead ?
                <Button id="area-manager-btn" sx={{display:showAreaManagerbutton?'block': 'none'}} variant="contained" onClick={handleAreaAssignment}>
                    {areaManagerActive? 'Save': 'Assign Area'}
                </Button>
                :
                <Button id="area-manager-btn" variant="contained" onClick={handlePanToArea}>
                    {'show my area'}
                </Button>
            }
            <DrawingManager
                onPolygonComplete={handlePolygonComplete}
                options={drawingManagerOptions}
                onLoad={(drawingManager) => (drawingManagerRef.current = drawingManager)}
            />
            {renderAreas}
            <Dialog onClose={()=>setOpen(false)} open={open}>
            <DialogTitle>Select a team member to assign this area</DialogTitle>
                <List sx={{ pt: 0 }}>
                    {teamData.members.map((member, idx) => (
                    <ListItem disableGutters key={idx}>
                        <ListItemButton
                            onClick={()=>handleAssignArea(member.name)}
                        >
                            <ListItemText
                                primary={member.name}
                            />
                        </ListItemButton>
                    </ListItem>
                    ))}
                </List>
            </Dialog>
        </>

    )
}

export default AreaManager;
